export const PROD_URL = "https://jiitu.co.id";
export const DEV_URL = "http://localhost:8000";
